import { CommonModule } from '@angular/common';
import { Component, effect, inject, model, signal, ViewChild } from '@angular/core';
import { AuthService } from 'app/core/services/auth/auth.service';
import { IUserMenuOption } from 'app/shared/interfaces/IMainLayout';
import { ButtonModule } from 'primeng/button';
import { Popover, PopoverModule } from 'primeng/popover';

@Component({
  selector: 'user-menu',
  standalone: true,
  imports: [CommonModule, PopoverModule, ButtonModule],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.css'
})
export class UserMenuComponent {
  readonly authService = inject(AuthService);
  visible = model<boolean>(false);
  private anchorEvent = signal<MouseEvent | null>(null);
  
  @ViewChild('op') op!: Popover;

  constructor (){
    effect(() => {
      const isOpen = this.visible();
      const ev = this.anchorEvent();

      if (!this.op) return;

      if (isOpen) {
        if (ev) this.op.show(ev);
      } else {
        this.op.hide();
      }
    });
  }

  options: IUserMenuOption[] = [
    /*
    {
      id: "1",
      name: 'Mi perfil',
      image: 'profile.svg',
      action: () => console.log("Ir al perfil")
    },
    {
      id: "2",
      name: 'Abrir Suite',
      image: 'suite.svg',
      action: () => console.log("Ir a la suite")
    },
    */
    {
      id: "3",
      name: 'Cerrar sesión',
      image: 'log-out.svg',
      action: () => this.authService.logout()
    },
  ];

  toggle(event: any) {
      this.op.toggle(event);
  }

  selectOption(option: IUserMenuOption) {
    this.op.hide();
    option.action();
  }

  anchor(ev: MouseEvent) {
    this.anchorEvent.set(ev);
  }

  onPopoverHide() {
    this.visible.set(false);
  }
}
